
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { InvestmentOpportunity } from "@/types/investment";

interface FinancialFieldsProps {
  formData: InvestmentOpportunity;
  onInputChange: (field: keyof InvestmentOpportunity, value: any) => void;
  onNumericChange: (field: keyof InvestmentOpportunity, value: string) => void;
}

const FinancialFields = ({ formData, onInputChange, onNumericChange }: FinancialFieldsProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="asking_price">Asking Price</Label>
        <Input
          id="asking_price"
          type="number"
          step="0.01"
          value={formData.asking_price === 0 ? '' : formData.asking_price}
          onChange={(e) => onNumericChange('asking_price', e.target.value)}
          placeholder="Enter amount"
        />
      </div>

      <div>
        <Label htmlFor="property_value">Property Value</Label>
        <Input
          id="property_value"
          type="number"
          step="0.01"
          value={formData.property_value === 0 ? '' : formData.property_value}
          onChange={(e) => onNumericChange('property_value', e.target.value)}
          placeholder="Enter property value"
        />
      </div>

      <div>
        <Label htmlFor="monthly_payment">Monthly Payment</Label>
        <Input
          id="monthly_payment"
          type="number"
          step="0.01"
          value={formData.monthly_payment === 0 ? '' : formData.monthly_payment}
          onChange={(e) => onNumericChange('monthly_payment', e.target.value)}
          placeholder="Enter amount"
        />
      </div>

      <div>
        <Label htmlFor="remaining_balance">Remaining Balance</Label>
        <Input
          id="remaining_balance"
          type="number"
          step="0.01"
          value={formData.remaining_balance === 0 ? '' : formData.remaining_balance}
          onChange={(e) => onNumericChange('remaining_balance', e.target.value)}
          placeholder="Enter amount"
        />
      </div>

      <div>
        <Label htmlFor="term_remaining">Term Remaining</Label>
        <Input
          id="term_remaining"
          value={formData.term_remaining}
          onChange={(e) => onInputChange('term_remaining', e.target.value)}
          placeholder="e.g., 84 months"
        />
      </div>

      <div>
        <Label htmlFor="buyer_payment_history_summary">Buyer Payment History</Label>
        <Textarea
          id="buyer_payment_history_summary"
          value={formData.buyer_payment_history_summary}
          onChange={(e) => onInputChange('buyer_payment_history_summary', e.target.value)}
          rows={2}
        />
      </div>

      <div>
        <Label htmlFor="buyer_credit_score_summary">Buyer Credit Score Summary</Label>
        <Input
          id="buyer_credit_score_summary"
          value={formData.buyer_credit_score_summary}
          onChange={(e) => onInputChange('buyer_credit_score_summary', e.target.value)}
          placeholder="e.g., Buyer Credit Score: 680 (Experian)"
        />
      </div>
    </div>
  );
};

export default FinancialFields;
